import(/* webpackMode: "eager" */ "/home/runner/work/capsicum/capsicum/apps/socios-web/app/(authenticated)/votes/[partnerId]/[surveyId]/page.tsx");
